import React from 'react';
import { Drawer, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const defaultProps = {
    rootStyle: {},
    paperStyle: {},
    listStyle: {},
    footerStyle: {},
    titleStyle: {},
    dialogContentStyle: {},
};
export const CustomDrawer = ({ anchorDirection, isOpen, children, rootStyle, paperStyle, listStyle, footer, footerStyle, extraClassName, onCloseCallBack, title, titleStyle, dialogContentStyle, variant }) => {
    const useStyles = makeStyles({
        root: rootStyle,
        paper: paperStyle,
        list: listStyle,
        footer: footerStyle,
        title: titleStyle,
        dialogContent: dialogContentStyle,
    });
    const classes = useStyles();
    return (React.createElement(Drawer, { variant: variant, classes: { paper: classes.paper, root: classes.root }, className: extraClassName ? extraClassName : '', anchor: anchorDirection, open: isOpen, onClose: onCloseCallBack },
        title && (React.createElement(DialogTitle, { className: classes.title }, title)),
        React.createElement(DialogContent, { className: classes.dialogContent, dividers: true },
            React.createElement(DialogContentText, { className: classes.list, id: "scroll-dialog-description", tabIndex: -1, component: "div" }, children)),
        footer && (React.createElement(DialogActions, { className: classes.footer }, footer))));
};
CustomDrawer.defaultProps = defaultProps;
